// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const acn: CountryValidator<"AU"> = createValidator(
  "au.acn",
  13,
);

export default acn;
export const compact = acn.compact;
export const format = acn.format;
export const validate = acn.validate;
export const generate = (): string =>
  acn.generate?.() ??
  (() => {
    throw new Error(
      "Validator au.acn cannot generate values",
    );
  })();
